/**
 * La cuenta atrás arranca en 22 h 15 min 30 s desde la primera visita.
 *
 * La fecha límite se guarda en sessionStorage, así que recargar la página no
 * reinicia el temporizador (solo vuelve a empezar en una sesión nueva).
 *
 * Para cerrar la promoción en una fecha fija, definí FIXED_DEADLINE con un ISO.
 */
const FIXED_DEADLINE: string | null = null

const START_MS = (22 * 3600 + 15 * 60 + 30) * 1000
const STORAGE_KEY = 'megapack-offer-deadline'

export function getOfferDeadline(): string {
  if (FIXED_DEADLINE) return FIXED_DEADLINE

  const fresh = new Date(Date.now() + START_MS).toISOString()
  if (typeof window === 'undefined') return fresh

  try {
    const stored = window.sessionStorage.getItem(STORAGE_KEY)
    if (stored && new Date(stored).getTime() > Date.now()) return stored
    window.sessionStorage.setItem(STORAGE_KEY, fresh)
  } catch {
    // sessionStorage bloqueado: la cuenta atrás simplemente reinicia al recargar.
  }

  return fresh
}

/** Porcentaje de cupos de lanzamiento ya tomados. */
export const spotsTakenPercent = 65
